import React from 'react';
import { Reveal } from '../../ui/Reveal';
import { bodySignals } from '../../../data/offer';
export function EmpathyCallout() {
  return <Reveal data-id="element-160" data-mp="13s82o1591cqu">
      <div className="mt-20 overflow-hidden rounded-3xl bg-cream" data-id="element-161" data-mp="13shs9nmdthw0">
        <div className="grid lg:grid-cols-2" data-id="element-162" data-mp="1hrhhawdt3ysp">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/03bbec86-4bb8-476b-938d-5907d3f8d288.jpg" alt="Mujer relajada disfrutando de una comida real junto a una ventana" className="h-56 w-full object-cover sm:h-72 lg:h-full" width={1200} height={900} loading="lazy" data-id="element-163" data-mp="1hq6g94bqx55a" />

          <div className="p-7 sm:p-10" data-id="element-164" data-mp="l05lmoop3ug2">
            <h3 className="text-[1.5rem] font-extrabold leading-[1.15] tracking-tight text-forest sm:text-3xl" data-id="element-165" data-mp="yu6ite0019eb">
              Tu cuerpo no es tu enemigo
            </h3>
            <p className="mt-4 text-[0.95rem] leading-relaxed text-body sm:text-base" data-id="element-166" data-mp="u13sdeqiqg2c">
              ¿Cansada de sentir que te falta voluntad? Tus antojos no son un fallo de carácter,
              son una señal biológica. Cuando estabilizas tu glucosa, el hambre emocional
              desaparece. No es magia, es medicina metabólica.
            </p>

            <ul className="mt-7 space-y-3" data-id="element-167" data-mp="v6s289cngpbi">
              {bodySignals.map(item => <li key={item.signal} className="flex flex-wrap items-baseline gap-x-2 border-l-[3px] border-gold bg-white px-4 py-3" data-id="element-168" data-mp="zy9um90lxhkv">
                  <span className="text-sm font-bold text-forest" data-id="element-169" data-mp="14xd01uki1ptd">{item.signal}</span>
                  <span className="text-sm text-muted" data-id="element-170" data-mp="7b76matk4p8v">=</span>
                  <span className="text-sm font-semibold text-ink" data-id="element-171" data-mp="c8yzp85xuhen">{item.meaning}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </Reveal>;
}